import { useChatMessages } from '@ai-sdk-tools/store';
import { IconAdd2 } from '@newfront-insurance/core-ui';
import {
  IconButtonAsButton,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@newfront-insurance/core-ui/v2';

import { useChatOverlayContext } from '../../contexts/chat-overlay-context';

interface NewChatButtonProps {
  className?: string;
}

/**
 * Button component for starting a new chat.
 * Uses chat overlay context to manage chat state.
 * Uses store messages to determine if button should be enabled
 * (since it's inside ChatProvider).
 */
export function NewChatButton({ className }: NewChatButtonProps) {
  const { startNewChat, isSidebarOpen } = useChatOverlayContext();
  const messages = useChatMessages();

  // Use store messages to determine if button should be enabled
  // This ensures the button state reflects the actual current chat state
  const hasAnyMessages = messages.length > 0;

  // Hide the button when sidebar is open
  if (isSidebarOpen) {
    return null;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <IconButtonAsButton onClick={startNewChat} disabled={!hasAnyMessages} className={className}>
            <IconAdd2 color="currentColor" />
          </IconButtonAsButton>
        </TooltipTrigger>
        <TooltipContent>Start a New Chat</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
